import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal auto_adjust popup deletinfoPopup" }
const _hoisted_2 = { class: "modal--content min--width--30" }
const _hoisted_3 = { class: "modal--body pb-4" }
const _hoisted_4 = { id: "loginform" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-10 col-xl-10 mx-auto" }
const _hoisted_7 = { class: "loginbtn" }
const _hoisted_8 = {
  key: 0,
  class: "btn btn--primary mb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal--backdrop",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dismiss(false)))
    }),
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "modal--header" }, [
        _createElementVNode("h4", { class: "text-white m-0" }, "Delete Post")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "blockusercontent text-center mb-4" }, [
                _createElementVNode("p", null, "Are you sure you want to delete this post?"),
                _createElementVNode("p", null, "You cannot undo it after deletion.")
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_8, _cache[3] || (_cache[3] = [
                      _createElementVNode("div", { class: "loader" }, null, -1)
                    ])))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClickOnce: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dismiss(true))),
                      class: "btn btn--primary mb-3"
                    }, " Confirm ", 32)),
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dismiss(false))),
                  href: "javascript:;"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}